import EditEmailModal from './edit-email-modal';

export default EditEmailModal;
